import Vue from 'vue';
import hello from './hello.vue';

export const initVue = () => {
  const app = document.getElementById('app');
  if (app) {
    new Vue({ el: app, render: (h) => h(hello) });
  }
};
